export enum TargetApiRoutes {
  Visualizations = 'main',
  Incentives = 'incentives',
  Incentive = 'incentive',
  Countries = 'countries',
  Country = 'country',
  Themes = 'themes',
  Filters = 'filters',
  Indicators = 'indicators'
}
